import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { TaskEntity } from '../../views/pages/calendar/models';
import { TaskEntityType } from '../../views/pages/calendar/enums';
import { SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class StringUtilsService {
  constructor(private datePipe: DatePipe, private titleCasePipe: TitleCasePipe) {}

  displayEntityForExternalAccess(entity: any): SafeHtml {
    let res = '';
    if (entity?.name) {
      res += entity.name;
    }
    if (!entity?.membersBiAccess) {
      const danger = 'Members do not have access to the BI App';
      res += ' ' + `<small class="text-danger">${danger}</small>`;
    }
    return res;
  }

  displayFullName(patient: any): string {
    let res = '';
    if (patient && patient.name) {
      res += patient.name;
    }
    if (patient && patient.first_name) {
      res += patient.first_name + ' ';
    }
    if (patient && patient.last_name) {
      res += patient.last_name + ' ';
    }
    if (patient && patient.last_name2) {
      res += patient.last_name2 + ' ';
    }
    if (patient && patient.practice_name) {
      res += '-' + patient.practice_name + ' ';
    }
    if (patient && patient.affiliation_groups && patient.affiliation_groups.length !== 0) {
      res += '-' + patient.affiliation_groups.map((res1) => res1.name).join(' ') + ' ';
    }
    if (
      patient &&
      !patient.practice_name &&
      patient.affiliation_groups &&
      patient.affiliation_groups.length === 0 &&
      patient.address1
    ) {
      res += '-' + patient.address1 + ' ';
    }
    if (patient && patient.dob) {
      res += '  ' + `<small class="text-muted">` + moment(patient.dob).format('l') + `</small>`;
    }
    return res;
  }

  displayUserName(val: any): string {
    if (val && val.fullName) {
      return val.fullName;
    }
    if (val && val.name) {
      return val.name;
    }
    return '';
  }

  displayDevice(device: any) {
    if (device && typeof device === 'object') {
      return device.name;
    }
  }
  filterCredentialFn(cred: any) {
    if (cred?.credentials_name) {
      return cred.credentials_name;
    }
  }

  displayAcceptanceName(obj: any) {
    let res = '';
    if (obj && obj.implementation) {
      res += obj.implementation;
    }
    return res;
  }

  displayOutcomeName(obj: any) {
    let res = '';
    if (obj && obj.outcome) {
      res += obj.outcome;
    }
    return res;
  }

  displayFolderName(obj: any) {
    let res = '';
    if (obj && obj.name) {
      res += obj.name;
    }
    return res;
  }

  displayInterventionCodeName(obj: any) {
    let res = '';
    if (obj && obj.description) {
      res += obj.description;
    }
    return res;
  }

  displayTeamName(obj: any) {
    let res = '';
    if (obj && obj.name) {
      res += obj.name;
    }
    return res;
  }

  displayName(obj: any) {
    let res = '';
    if (obj && obj.name) {
      res += obj.name;
    }
    if (obj && obj.first_name) {
      res += obj.first_name + ' ';
    }
    if (obj && obj.last_name) {
      res += obj.last_name + ' ';
    }
    if (obj && obj.last_name2) {
      res += obj.last_name2;
    }
    if (obj && obj.practice_name) {
      res += '-' + obj.practice_name + ' ';
    }
    if (obj && obj.affiliation_groups && obj.affiliation_groups.length !== 0) {
      res += '-' + obj.affiliation_groups.map((res1) => res1.name).join(' ') + ' ';
    }
    if (
      obj &&
      !obj.practice_name &&
      obj.affiliation_groups &&
      obj.affiliation_groups.length === 0 &&
      obj.address1
    ) {
      res += '-' + obj.address1 + ' ';
    }
    return res;
  }

  displayProgram(event: any): string {
    return event && event.program ? event.program.name : '';
  }

  formatDate(date, format = 'MM/dd/yyyy') {
    try {
      date = new Date(date);
      const userTimezoneOffset = date.getTimezoneOffset() * 60000;
      date.setTime(date.getTime() + userTimezoneOffset);
      return this.datePipe.transform(date.toLocaleDateString(), format);
    } catch (e) {
      return 'Non-Cycle';
    }
  }

  formatDateDiff(from: any = new Date(), to: any = new Date()) {
    to = moment(to);
    from = moment(from);
    const tempTime = moment.duration(to.diff(from));
    return Math.round(tempTime.asHours() * 10) / 10 + ' Hours';
  }

  autocompleteEntityFormatter(entity) {
    if (!entity) return '';
    let name = '';

    let subTitle =
      new TitleCasePipe().transform((entity.entity_type ? entity.entity_type : entity.type) || '') +
      ' ';

    if (entity.name) {
      name += entity.name;
    } else {
      if (entity.first_name) {
        name += entity.first_name;
      }
      if (entity.last_name) {
        name += ' ' + entity.last_name;
      }
    }
    if (entity.last_name2) {
      name += ' ' + entity.last_name2;
    }

    if (entity && entity.practice_name) {
      name += '-' + entity.practice_name + ' ';
    }
    if (entity && entity.affiliation_groups && entity.affiliation_groups.length !== 0) {
      name += '-' + entity.affiliation_groups.map((res1) => res1.name).join(' ') + ' ';
    }
    if (
      entity &&
      !entity.practice_name &&
      entity.affiliation_groups &&
      entity.affiliation_groups.length === 0 &&
      entity.address1
    ) {
      name += '-' + entity.address1 + ' ';
    }

    if (entity.entity_type === 'DOCTOR' || entity.npi) {
      subTitle += entity.npi ? entity.npi : entity.phone ? entity.phone : '';
    } else if (entity.entity_type === 'FACILITY' || entity.facility_code) {
      subTitle += entity.facility_code ? entity.facility_code : entity.phone ? entity.phone : '';
    } else {
      if (entity.entity_type === 'PATIENT' && moment(entity.dob).isValid())
        subTitle += moment.utc(entity.dob).format('ll');
      else if (entity.cell_phone) {
        subTitle += entity.cell_phone;
      }
    }
    const classList =
      entity.is_active ||
      entity.isActive ||
      (!Object.prototype.hasOwnProperty.call(entity, 'is_active') &&
        !Object.prototype.hasOwnProperty.call(entity, 'isActive'))
        ? ''
        : 'text-danger';
    return `<div><span class="${classList}">${name}</span> <small class="text-muted">${subTitle}</small></div>`;
  }

  formatEntityOptionActiveInactive(entity: TaskEntity): string {
    const classList =
      entity.is_active ||
      entity.isActive ||
      (!Object.prototype.hasOwnProperty.call(entity, 'is_active') &&
        !Object.prototype.hasOwnProperty.call(entity, 'isActive'))
        ? ''
        : 'text-danger';
    return entity?.id
      ? entity.entity_type === TaskEntityType.PATIENT
        ? `<div>
          <div class="mb-2">
            <span class="${classList}">${
            entity.name ||
            `${entity.first_name || ''} ${entity.last_name || ''} ${entity.last_name2 || ''}`.trim()
          }</span>
            ${
              entity.entity_id
                ? `<small class="text-primary ml-2">#${entity.entity_id}</small>`
                : ''
            }
            ${
              entity.entity_type
                ? `<small class="text-muted ml-2">(${entity.entity_type})</small>`
                : ''
            }
          </div>
          <div class="font-size-sm">
            <div><i class="fa fa-birthday-cake font-size-sm mr-2"></i>${
              entity.dob?.substring(0, entity.dob?.indexOf('T')) || '-'
            }</div>
            <div><i class="fa fa-building font-size-sm mr-2"></i>${
              entity.facility_name || '-'
            }</div>
          </div>
        </div>`
        : `<div>
          <span class="${classList}">${
            entity.name || `${entity.first_name || ''} ${entity.last_name || ''}`.trim()
          }</span>
          ${
            entity.entity_type
              ? `<small class="text-muted ml-2">(${entity.entity_type})</small>`
              : ''
          }
        </div>`
      : '';
  }

  formatEntityValueActiveInactive(entity: TaskEntity): string {
    const classList =
      entity.is_active ||
      entity.isActive ||
      (!Object.prototype.hasOwnProperty.call(entity, 'is_active') &&
        !Object.prototype.hasOwnProperty.call(entity, 'isActive'))
        ? ''
        : 'text-danger';

    if (!entity?.id) return '';

    const value = entity.name || `${entity.first_name || ''} ${entity.last_name || ''}`.trim();
    return classList ? `<span class="${classList}">${value}</span>` : value;
  }

  displaySpecialties(val) {
    let res = '';
    if (val) {
      res += val.description;
    }
    return res;
  }

  getEntityHeader(entityType: string): string {
    const containerOpenTag =
      '<div class="entity-header d-flex align-items-center font-size-base font-weight-bolder w-100"><style>.entity-header :not(:last-child) { padding-right: 10px }</style>';
    const containerCloseTag = '</div>';
    const id = '<div style="width: 100px">ID</div>';
    const firstName = '<div style="width: 100px">First Name</div>';
    const lastName = '<div style="width: 100px">Last Name</div>';
    const lastName2 = '<div style="width: 100px">Last Name 2</div>';
    const name = '<div style="width: 200px" class="flex-grow-1">Name</div>';
    const practiceName = '<div style="width: 100px">Practice Name</div>';
    const affiliations = '<div style="width: 100px">Affiliations</div>';
    const email = '<div style="width: 200px" class="flex-grow-1">Email</div>';
    const cellPhone = '<div style="width: 100px">Cell Phone</div>';
    const phone = '<div style="width: 100px">Phone</div>';
    const address = '<div style="width: 100px">Address</div>';

    switch (entityType) {
      case 'PATIENT':
        return (
          containerOpenTag +
          id +
          firstName +
          lastName +
          lastName2 +
          email +
          cellPhone +
          address +
          containerCloseTag
        );

      case 'DOCTOR':
        return (
          containerOpenTag +
          id +
          firstName +
          lastName +
          lastName2 +
          practiceName +
          affiliations +
          email +
          cellPhone +
          address +
          containerCloseTag
        );

      case 'CONTACT':
        return (
          containerOpenTag +
          firstName +
          lastName +
          lastName2 +
          email +
          cellPhone +
          address +
          containerCloseTag
        );
      case 'CLIENT':
        return (
          containerOpenTag +
          firstName +
          lastName +
          lastName2 +
          email +
          cellPhone +
          address +
          containerCloseTag
        );
      case 'FACILITY':
      case 'PHARMACY':
        return containerOpenTag + name + email + phone + address + containerCloseTag;

      default:
        return '';
    }
  }

  getEntityFormatter(entityType: string, entity: any): string {
    if (!entity) return '';

    const containerOpenTag = `<div class="entity-record d-flex align-items-center font-size-base font-weight-normal w-100${
      entity.is_active || entity.isActive ? '' : ' text-danger'
    }"><style>.entity-record :not(:last-child) { padding-right: 10px }</style>`;
    const containerCloseTag = '</div>';
    const id = `<div style="width: 100px">${entity.patient_id || ''}</div>`;
    const npi = `<div style="width: 100px">${entity.npi || ''}</div>`;
    const firstName = `<div style="width: 100px">${entity.first_name || ''}</div>`;
    const lastName = `<div style="width: 100px">${entity.last_name || ''}</div>`;
    const lastName2 = `<div style="width: 100px">${entity.last_name2 || ''}</div>`;
    const name = `<div style="width: 200px" class="flex-grow-1">${entity.name || ''}</div>`;
    const practiceName = `<div style="width: 100px">${entity.practice_name || ''}</div>`;
    const affiliations = `<div style="width: 100px">${
      entity.affiliation_groups?.length
        ? entity.affiliation_groups.map((group) => group.name).join(', ')
        : ''
    }</div>`;
    const email = `<div style="width: 200px" class="flex-grow-1">${entity.email || ''}</div>`;
    const cellPhone = `<div style="width: 100px">${entity.cell_phone || ''}</div>`;
    const phone = `<div style="width: 100px">${entity.phone || ''}</div>`;
    const address = `<div style="width: 100px">${entity.address_1 || ''}</div>`;

    switch (entityType) {
      case 'PATIENT':
        return (
          containerOpenTag +
          id +
          firstName +
          lastName +
          lastName2 +
          email +
          cellPhone +
          address +
          containerCloseTag
        );

      case 'DOCTOR':
        return (
          containerOpenTag +
          npi +
          firstName +
          lastName +
          lastName2 +
          practiceName +
          affiliations +
          email +
          cellPhone +
          address +
          containerCloseTag
        );

      case 'CONTACT':
        return (
          containerOpenTag +
          firstName +
          lastName +
          lastName2 +
          email +
          cellPhone +
          address +
          containerCloseTag
        );
      case 'CLIENT':
        return (
          containerOpenTag +
          firstName +
          lastName +
          lastName2 +
          email +
          cellPhone +
          address +
          containerCloseTag
        );

      case 'FACILITY':
      case 'PHARMACY':
        return containerOpenTag + name + email + phone + address + containerCloseTag;

      default:
        return '';
    }
  }

  getEntitySearchFields(entityType: string): { label: string; value: string }[] {
    const searchFields = [
      // index
      { label: 'ID', value: 'entity_id_has' }, // 0
      { label: 'ID', value: 'npi_has' }, // 1
      { label: 'First Name', value: 'first_name_has' }, // 2
      { label: 'Last Name', value: 'last_name_has' }, // 3
      { label: 'Last Name 2', value: 'last_name2_has' }, // 4
      { label: 'Cell Phone', value: 'cell_phone_has' }, // 5
      { label: 'Name', value: 'last_name_has' }, // 6
      { label: 'Phone', value: 'phone_has' }, // 7
      { label: 'Email', value: 'email_has' }, // 8
      { label: 'Address', value: 'address1_has' }, // 9
      { label: 'All', value: '' }, // 10
    ];

    switch (entityType) {
      case 'PATIENT':
        return [searchFields[0], ...searchFields.slice(2, 6), ...searchFields.slice(8)];

      case 'DOCTOR':
        return [...searchFields.slice(1, 6), ...searchFields.slice(8)];

      case 'CONTACT':
        return [...searchFields.slice(2, 6), ...searchFields.slice(8)];
      case 'CLIENT':
        return [...searchFields.slice(2, 6), ...searchFields.slice(8)];
      case 'FACILITY':
      case 'PHARMACY':
        return [...searchFields.slice(6)];

      default:
        return [];
    }
  }

  getLocalDate(date): Date {
    try {
      if (date) {
        const d = new Date(date);
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());

        return d;
      } else return null;
    } catch (err) {
      return null;
    }
  }

  formatEnumString(enumString: any): string {
    return enumString ? this.titleCasePipe.transform(enumString.replace(/_/g, ' ')) : '';
  }
}
